import React from "react";

const Plugin = ({ tool, plugin }) => {
  const { w: width, h: height, x: left, y: top, a: toolAngle } = tool;
  const pluginStyle = {
    position: "absolute",
    width,
    height,
    left,
    top,
    transform: `rotate(${toolAngle}deg)`,
    zIndex: 1000,
  };

  return <div style={pluginStyle}>{plugin}</div>;
};

export default Plugin;
